const mutations = {
  showDialog(state) {
    state.dialog = true;
  },

  hideDialog(state) {
    state.dialog = false;
  },

  setModel(state, model) {
    state.errorArray = [];
    state.turno = model;
  },

  setModels(state, models) {
    state.turnos = models;
  },

  addModel(state, model) {
    state.nuevo = true;
    state.turnos.unshift(model);
  },

  delModel(state, id) {
    const removeIndex = state.carreras
      .map(function (item) {
        return item.id;
      })
      .indexOf(id);
    state.turnos.splice(removeIndex, 1);
  },

  setErrors(state, errors) {
    state.errorArray = errors;
  },

  setFields(state, data) {
    state.fields = data.fields;
    state.emptyModel = data.model;
  },
};

export default mutations;
